import Button from '../ui/Button';
import Select from '../ui/Select';

/**
 * Exit/Emergency Light failure-reason dropdown and the Pass/Fail toggle for
 * RecordTestModal. Extracted from RecordTestModal.jsx (Brief 44); converted
 * from checkboxes to the single-select dropdown every other asset type uses
 * (Brief 36) — one control for the same job, instead of three.
 *
 * Props:
 *   register — react-hook-form register fn.
 *   failureOptions — asset-type failure reason options ('exit_light' or
 *     'emergency_light' from `FAILURE_OPTIONS`).
 *   showFailReasons — whether the failure-reason dropdown is shown (vs the
 *     "Currently passing" toggle).
 *   onMarkAsPass — clears the failure reason and hides the reason block.
 *   onAddFailureDetails — reveals the failure-reason dropdown.
 *   unmatchedOriginalText — set when an existing record's stored text could
 *     not be matched to exactly one option (ambiguous multi-reason text, or
 *     text this dropdown cannot represent). Shown read-only so an edit is
 *     never made blind to what was actually recorded; see Brief 36 Part 3.
 */
export default function ExitEmergencyFailureFields({
  register,
  failureOptions,
  showFailReasons,
  onMarkAsPass,
  onAddFailureDetails,
  unmatchedOriginalText,
}) {
  if (showFailReasons) {
    return (
      <div className="form-group">
        <Select
          id="record-test-failure-reason"
          label="Reason for Failure"
          {...register('failureReason')}
        >
          <option value="">Select reason</option>
          {failureOptions.map((reason) => (
            <option key={reason} value={reason}>
              {reason}
            </option>
          ))}
        </Select>
        {unmatchedOriginalText && (
          <p className="text-muted" style={{ marginTop: 4 }}>
            Originally recorded: &quot;{unmatchedOriginalText}&quot;. Select a reason above to
            update it, or leave as is to keep the original record unchanged.
          </p>
        )}
        <div style={{ marginTop: 8 }}>
          <Button
            type="button"
            size="sm"
            onClick={onMarkAsPass}
          >
            Mark as Pass
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="form-group">
      <label>Result mode</label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <span className="text-muted">Currently passing. Add failure reasons to record a fail.</span>
        <Button
          type="button"
          size="sm"
          className="record-test-add-failure-btn"
          onClick={onAddFailureDetails}
        >
          Add failure details
        </Button>
      </div>
    </div>
  );
}
